import styled, { css } from 'styled-components';
export const Container = styled.div `
  border-bottom: 1px solid var(--border-tertiary);

  ${({ $spacing }) => $spacing === 'tiny' &&
    css `
      padding: var(--space-200) 0;
    `}

  ${({ $spacing }) => $spacing === 'small' &&
    css `
      padding: var(--space-300) 0;
    `}

  ${({ $spacing }) => $spacing === 'regular' &&
    css `
      padding: var(--space-400) 0;
    `}

  &:last-child {
    border-bottom: none;
  }
`;
export const HeadingContainer = styled.div `
  display: flex;
  align-items: center;
  font-weight: var(--font-weight-semibold);
  position: relative;
`;
export const Heading = styled.div `
  flex: 1;
`;
export const ExpandButton = styled.button `
  margin-left: var(--space-200);
  margin-right: var(--space-n200);
  padding: var(--space-200);

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;
